import React from 'react';
import Box from '@material-ui/core/Box/Box';
import Routes from "./Route/router";
import { ToastContainer } from 'react-toastify';
import CommonTheme from "@project/shared/src/theme/commonTheme";
import { makeStyles } from '@material-ui/core/styles';
import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles((theme) => ({
  toasterStyle: {
    "& >div":{
      minHeight:0
    }
  },

}));

const App = () => {
  const classes = useStyles();
    return (
        <Box>
          <CommonTheme>

          <Routes/>
            <ToastContainer
              position="top-center"
              style={{top: '0px', padding:'0'}}
              autoClose={3000}
              className={classes.toasterStyle}
            />
          </CommonTheme>
        </Box>
    );
};
export default App;
